import * as Sentry from '@sentry/react';

const defaultFallback = <p>Something went wrong. Please refresh the page.</p>;

export function SentryPageBoundary({ children, boundaryName = 'ui', fallback = defaultFallback }) {
    return (
        <Sentry.ErrorBoundary
            fallback={fallback}
            beforeCapture={(scope) => {
                scope.setTag('ui.boundary', boundaryName);
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
}